<template>
	<div>
		<div class="list-btn">
<!--			 <Button type="primary" @click="add"  v-if="query.parentId!=null">新增</Button>-->
			<Button type="primary"  @click="shangji" v-if="query.parentId!=null">返回上级</Button>

		</div>
		<div class="list-btn">
			<!-- <div style="margin-right: 10px;" v-for="(item,i) in daoh" :key="item.parentId" >{{item.name}} &nbsp;&nbsp;/</div> -->

		</div>
		<!-- <Breadcrumb v-if="row.level!=1">
			<BreadcrumbItem>Home</BreadcrumbItem>
			<BreadcrumbItem>Breadcrumb</BreadcrumbItem>
		</Breadcrumb> -->
		<div class="list-btn">
			<div class="jiams">
				<!-- <div>商品类别：</div>
				<Cascader :data="data4" :load-data="loadData" :change-on-select="true" :not-found-text="kong" @on-change="onChange" @on></Cascader> -->
				<!-- <Select v-model="query.typeId" multiple style="width:300px"  @on-change="onchangeSousuo">
				        <Option v-for="item in types" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select> -->
			</div>
			<!-- <Input style="width: 450px;" search enter-button placeholder="请输入商品名称/类型查询" v-model="query.like" @on-search="onsearch"/> -->

		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				 <Button type="primary" size="small" style="margin-right: 5px" @click="xiaji(row)" v-show="row.level!=2">下级分类</Button>
				<!-- <Button type="primary" size="small" style="margin-right: 5px"  v-if="query.parentId!=null" @click="update(row.id)">修改</Button> -->
			<!-- 	<Button  size="small" style="margin-right: 5px" class="delete" @click="remove(row.id)" v-show="row.state==false" >启用</Button>
				<Button  size="small" style="margin-right: 5px" class="error" @click="remove(row.id)" v-show="row.state==true">禁用</Button> -->

			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
import http from '@/http/http.js'
import page from '@/components/comm/page.vue'
export default {
  data () {
    return {
      empType: '',
      daoh: [
        {name: '商品分类', parentId: null}
      ],
      loading: false,
      total: 100,
      columns12: [{
        title: 'id',
        key: 'id',
        width: 150,
        align: 'center'
      },
      {
        title: '名称',
        key: 'name',
        width: 150,
        align: 'center'
      },
      {
        title: '描述',
        key: 'typeExplain',
        width: 200,
        align: 'center'
      },
      {
        title: '抽成比例',
        key: 'rake',
        width: 200,
        align: 'center',
        render: (h, params) => {
          return h('div', params.row.rake / 100 + '%')
        }
      },
      {
        title: '状态',
        key: 'state',
        width: 180,
        align: 'center',
        render: (h, params) => {
          if (params.row.state == true) {
            return h('div', '启用')
          } else {
            return h('div', '禁用')
          }
        }
      },
      {
        title: '录入时间',
        key: 'createdTime',
        width: 240,
        align: 'center'
      },
      {
        title: '操作',
        slot: 'action',
        width: 200,
        align: 'center'
      }
      ],
      data6: [
        {
          /* id: '1',
						name: '饮料',
						state: '启用',
						createdTime: '2010-10-10',
						cz: '' */
        }
      ],
      sj: [0],
      query: {
        page: 0,
        size: 10,
        level: 0,
        parentId: 0
      }

    }
  },
  methods: {
    shangji () {
      console.log(this.sj[this.sj.length - 1])
      this.query.parentId = this.sj[this.sj.length - 1]
      this.sj.splice(this.sj.indexOf(this.sj[this.sj.length - 1]), 1)
      this.ajaxPage()
      this.daoh.pop()
    },
    update (id) { // 修改
      this.$router.push({
        name: 'oper/comm/type/update',
        query: {
          id: id
        }
      })
    },
    xiaji (item) {
      // this.$router.push({
      // 	name: 'jm/finance/type/list2',
      // 	query:{
      // 		id:id
      // 	}
      // })
      let a = {
        name: item.name,
        parentId: item.id
      }
      this.daoh.push(a)
      this.sj.push(this.query.parentId)
      this.query.parentId = item.id
      this.ajaxPage()
    },
    remove (id) {
      let _this = this
      http.http({
				    // 这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComType/update/state',
				    data: {id: id},
        _this: _this,
        success: function (data) {
          _this.modal_loading = false
          _this.modal2 = false
          _this.$Message.success('修改成功！！！')
          _this.ajaxPage()
        }
				    // 假设后台需要的是表单数据这里你就可以更改
				  })
    },
    add () {
      let _this = this
      this.$router.push({
        name: 'oper/comm/type/add',
        query: {
          parentId: this.query.parentId
        }
      })
    },
    updatePage (page) { // 页码改变的回调，返回改变后的页码
      this.query.page = page - 1
      this.ajaxPage()
    },
    updateSize (size) { // 切换每页条数时的回调，返回切换后的每页条数
      this.query.size = size
      this.ajaxPage()
    },
    ajaxPage () {
      this.loading = true
      let _this = this

      http.http({
				    // 这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComType/page/oper/all',
				    data: _this.query,
        _this: _this,
        success: function (data) {
          _this.total = data.page.totalElements
          _this.data6 = data.page.content
          _this.loading = false
        }
				  })
    }
  },
	    components: {
	    	page
	    },
  created () {
    this.empType = JSON.parse(sessionStorage.getItem('user')).empType
    this.ajaxPage()
  },
  activated () {
    this.ajaxPage()
  }
}
</script>
<style scoped="scoped">
	.list-btn {
		display: flex;
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/commodity/type/list.vue